import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-forest-dark text-cream-dark py-12 border-t border-forest-light" data-id="element-41">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-42">
        <h4 className="text-gold font-bold text-xl mb-6 font-heading" data-id="element-43">
          EL CÓDIGO METABÓLICO LATINO
        </h4>

        <div className="max-w-3xl text-xs md:text-sm opacity-60 mb-8 space-y-4 leading-relaxed" data-id="element-44">
          <p data-id="element-45">
            <strong data-id="element-46">Descargo de responsabilidad médico:</strong> Este producto
            no sustituye el consejo médico profesional, diagnóstico o
            tratamiento. Siempre busque el consejo de su médico u otro proveedor
            de salud calificado con cualquier pregunta que pueda tener sobre una
            condición médica. Nunca ignore el consejo médico profesional ni se
            demore en buscarlo debido a algo que haya leído en este sitio web o
            en nuestros materiales.
          </p>
          <p data-id="element-47">
            Los resultados pueden variar de persona a persona. Los testimonios
            mostrados son experiencias reales, pero no garantizan resultados
            idénticos para todos los usuarios.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between w-full pt-8 border-t border-forest-light/30 text-sm opacity-80" data-id="element-48">
          <p data-id="element-49">
            &copy; {currentYear} El Código Metabólico Latino. Todos los derechos
            reservados.
          </p>
          <div className="mt-4 md:mt-0 flex space-x-6" data-id="element-50">
            <a href="#" className="hover:text-gold transition-colors" data-id="element-51">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-52">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-53">
              Contacto
            </a>
          </div>
        </div>
      </div>
    </footer>;
}